import { IconModuleRequestFeedback, IconUserArrowOut } from 'featherico';
import type { ReactElement } from 'react';
import { ANYTIME_FEEDBACK_GIVE_CREATE, ANYTIME_FEEDBACK_REQUEST_CREATE } from '../../../../../routes';
import Modal from '../../../../components/Modal';
import { SelectButton } from '../../../../components/SelectButton';
import { TOUR_EMPLOYEE_ANYTIME_FEEDBACK } from '../../../../intercom/intercom-data-targets';
import styles from './style.m.less';

interface AnytimeFeedbackTypeSelectProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function AnytimeFeedbackTypeSelectModal({
    isOpen,
    onClose,
}: AnytimeFeedbackTypeSelectProps): ReactElement {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className={styles.container}>
                <SelectButton
                    route={ANYTIME_FEEDBACK_REQUEST_CREATE}
                    onClose={onClose}
                    title="Request Feedback"
                    description="Request feedback from team members about yourself, a specific topic or another team member's performance."
                    icon={IconModuleRequestFeedback}
                    color="SALMON"
                />
                <SelectButton
                    route={ANYTIME_FEEDBACK_GIVE_CREATE}
                    onClose={onClose}
                    title="Give Feedback"
                    description="Proactively give feedback to team members, about a specific topic or another team member's
                    performance."
                    icon={IconUserArrowOut}
                    color="TURQUOISE"
                    data-intercom-target={TOUR_EMPLOYEE_ANYTIME_FEEDBACK.BUTTON_GIVE_FEEDBACK}
                />
            </div>
        </Modal>
    );
}
